import Temporal from "../time/temporal"
import { isDatetimeType } from "./types.js"

class QueryResult {
  constructor(row, meta) {
    this.row = row
    this.meta = meta
    this.parsed = {}
  }

  field(name) {
    const idx = this.meta.idx(name)
    if(idx === undefined) return;

    return this.row[idx]
  }

  get selectedFields() {
    return this.slice(...this.meta.fields)
  }

  at(idx) {
    return this.field(this.meta.fields[idx]);
  }

  tsUTC() {
    const typeInfo = this.meta.type("@ts");
    if (!typeInfo) return this.field("@ts");

    const [tz, abbr] = typeInfo.split(".");
    if(tz === "tzdatetime") {
      return Temporal.convertFromTz(this.field("@ts"), abbr)
    } else {
      return this.field("@ts")
    }
  }

  slice(...fields) {
    return(
      fields.reduce(
        ((coll, n) => ({...coll, [n]: this.field(n)})),
        {}
      )
    )
  }

  parsedField(name) {
    if(this.parsed[name]) return this.parsed[name];

    const val = this.field(name);
    if(isDatetimeType(this.meta.type(name))) {
      return this.parsed[name] = new Date(Date.parse(val));
    }

    return val;
  }
}

export default QueryResult
